const STORAGE_KEY = "seen_si_thought_traces";

// A trace is generated for a cycle + brand + imperative, so the same imperative under another
// brand or cycle is a trace the user has not watched yet.
const traceKey = (cycle, brand, strategicImperative) => [cycle, brand, strategicImperative].join("::");

function getSeenTraceKeys() {
    try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(stored) ? stored.filter((key) => typeof key === "string") : [];
    } catch {
        return [];
    }
}

export function hasSeenSiThoughtTrace(cycle, brand, strategicImperative) {
    return getSeenTraceKeys().includes(traceKey(cycle, brand, strategicImperative));
}

export function rememberSiThoughtTrace(cycle, brand, strategicImperative) {
    const key = traceKey(cycle, brand, strategicImperative);
    const keys = getSeenTraceKeys();
    if (!keys.includes(key)) {
        keys.push(key);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(keys));
    }
}

// The reveal belongs to the session that watched it, so signing out or signing back in
// hands the next user every trace from the start.
export function forgetSiThoughtTraces() {
    localStorage.removeItem(STORAGE_KEY);
}
